import React, { useCallback, useMemo } from 'react';

import { MoreButtonCDS } from '@sharedCR/coreDesignSystem/Buttons';
import { EditPenIcon } from '@sharedCR/coreDesignSystem/icons';
import MenuPopoverCDS from '@sharedCR/coreDesignSystem/MenuPopoverCDS';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import usePopover from 'hooks/usePopover';

import { UnderwritingTestIds } from '../../Underwriting.testIds';

import { buttonStyles } from './ActionButton.styles';

const ActionButton = ({
  isDisabled = false,
  isEditDisabled = false,
  rowData = '',
  onEdit = _.noop,
}) => {
  const { anchorEl, onSetAnchorElement, onClearAnchorElement } = usePopover();

  const onClickEdit = useCallback(() => {
    onClearAnchorElement();

    onEdit(rowData);
  }, [onClearAnchorElement, rowData, onEdit]);

  const items = useMemo(
    () => [
      {
        text: 'Edit',
        onClick: onClickEdit,
        icon: <EditPenIcon size={IconSize[20]} />,
        isDisabled: isEditDisabled,
      },
    ],
    [onClickEdit, isEditDisabled],
  );

  return (
    <>
      <MoreButtonCDS
        customStyles={buttonStyles}
        data-testid={UnderwritingTestIds.NOTES_ACTION_BUTTON}
        disabled={isDisabled}
        isSelected={!!anchorEl}
        onClick={onSetAnchorElement}
      />

      <MenuPopoverCDS anchorEl={anchorEl} items={items} onClose={onClearAnchorElement} />
    </>
  );
};

ActionButton.propTypes = {
  isDisabled: PropTypes.bool,
  isEditDisabled: PropTypes.bool,
  rowData: PropTypes.string,
  onEdit: PropTypes.func,
};

export default ActionButton;
